import React from "react";
import Card, { CardHeader } from "components/card";
import { EmptyState } from "components/states";
import { formatNumber } from "utils/format";
import DistributionBar from "./DistributionBar";
import StatTile from "./StatTile";

const ChoiceDistributionCard = ({ type, options, distribution, totalResponses }) => {
  const isMultipleChoice = type === "multiple_choice";

  if (!totalResponses || totalResponses === 0) {
    return (
      <Card padding="md">
        <EmptyState variant="inline" title="No responses yet" />
      </Card>
    );
  }

  // Multiple choice: % of respondents who picked the option. Single choice: % of responses.
  const optionsData = (options || Object.keys(distribution || {})).map((option) => {
    const count = distribution?.[option] || 0;
    const percent = totalResponses > 0 ? Math.round((count / totalResponses) * 100) : 0;
    return { option, count, percent };
  });
  optionsData.sort((a, b) => b.count - a.count);

  const totalSelections = Object.values(distribution || {}).reduce((sum, c) => sum + c, 0);
  const avgSelectionsPerRespondent =
    totalResponses > 0 ? (totalSelections / totalResponses).toFixed(1) : 0;

  return (
    <div className="flex flex-col gap-5">
      {isMultipleChoice && (
        <dl className="grid grid-cols-2 gap-4">
          <StatTile label="Respondents" value={formatNumber(totalResponses)} />
          <StatTile label="Avg Selections" value={avgSelectionsPerRespondent} />
        </dl>
      )}

      <Card padding="md">
        <CardHeader
          title={
            isMultipleChoice ? "% of Respondents Who Selected Each Option" : "Response Distribution"
          }
          titleAs="h4"
          description={`Out of ${formatNumber(totalResponses)} ${
            isMultipleChoice ? "respondents" : "responses"
          }`}
        />
        <ul className="mt-4 space-y-3">
          {optionsData.map((item) => (
            <DistributionBar
              key={item.option}
              label={item.option}
              percent={item.percent}
              count={item.count}
              labelClassName="w-28 sm:w-40"
            />
          ))}
        </ul>
      </Card>
    </div>
  );
};

export default ChoiceDistributionCard;
